import React from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { AnimatePresence, motion } from "framer-motion"
import { Swiper, SwiperSlide } from "swiper/react"
import { Virtual } from "swiper/modules"
import { styled } from "@mui/material/styles"
import Modal from "@mui/material/Modal"
import { useAppSelector } from "appRedux/hooks"
import { updatePremiumCurrentOnboardingSlide, updateShowPremiumOnboarding } from "appRedux/slices/premiumSlice"
import useBackListener from "hooks/useBackListener"
import SwiperIndicator from "components/molecules/SwiperIndicator"
import PremiumOnboardingSlide from "components/templates/PremiumOnboarding/OnboardingSlide"

export default function PremiumOnboarding() {
  const showPremiumOnboarding = useAppSelector((state) => state.premium.showPremiumOnboarding)
  const currentPremiumOnboardingSlide = useAppSelector((state) => state.premium.currentPremiumOnboardingSlide)
  const PREMIUM_SLIDES_FOR_ACTIVE_FEATURES = useAppSelector((state) => state.premium.premiumSlidesForActiveFeatures)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useBackListener(showPremiumOnboarding, handleBackListenerCallback)

  function handleBackListenerCallback() {
    dispatch(updateShowPremiumOnboarding(false))
  }

  function handleOnSlideChange(swiperEvent: any) {
    dispatch(updatePremiumCurrentOnboardingSlide(swiperEvent.activeIndex))
  }

  function handleClosePremiumOnboarding() {
    dispatch(updateShowPremiumOnboarding(false))
    navigate(-1)
  }

  return (
    <Container id="onboarding-container" open={showPremiumOnboarding}>
      <div>
        <AnimatePresence>
          {showPremiumOnboarding && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.1, ease: "easeOut" }}
            >
              <Swiper
                dir="ltr"
                initialSlide={currentPremiumOnboardingSlide}
                resistanceRatio={0}
                edgeSwipeDetection={true}
                modules={[Virtual]}
                virtual
                onSlideChange={handleOnSlideChange}
              >
                {PREMIUM_SLIDES_FOR_ACTIVE_FEATURES.map((slide, index) => (
                  <SwiperSlide key={slide.key} virtualIndex={index}>
                    <PremiumOnboardingSlide
                      data={slide}
                      onClose={handleClosePremiumOnboarding}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <SwiperIndicator
                slidesCount={PREMIUM_SLIDES_FOR_ACTIVE_FEATURES.length}
                currentSlideIndex={currentPremiumOnboardingSlide}
                mode={PREMIUM_SLIDES_FOR_ACTIVE_FEATURES[currentPremiumOnboardingSlide]?.theme}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Container>
  )
}

const Container = styled(Modal)(() => ({
  width: "100vw",
  maxWidth: "var(--max-container-width)",
  height: "100vh",
  position: "fixed",
  top: 0,
  zIndex: 100000,

  "@supports (height: 100dvh)": {
    height: "calc(100dvh)"
  }
}))
